import * as React from 'react';
import type { NumberLiteralDataType } from '@glueapp/graph-types';

interface NumberValueEditorProps {
    type: NumberLiteralDataType;
}

export const NumberLiteralValueEditor: React.FC<NumberValueEditorProps> = ({ type }) => {
    return (
        <div className="flex flex-col pt-1">
            <h4 className="text-foreground text-sm m-0 mb-1">{type.numberLiteral}</h4>
        </div>
    );
};
